import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateTopThreats = document.createElement('template');

templateTopThreats.innerHTML = `
  <style>${styles}</style>
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <div class="wrapper widget-2-3-ratio">
    <h2 class="display-2 widget-title">
        <span id="topThreatTitle"></span>
        ${renderErrorStateIcon()}
    </h2>


    <div class="content top-threats-container">
      <ul id="topThreatList" class="threats-list">
        <li class="gz-data-item gz-data-list-item">
          <span class="gz-data-item--bullet" gz-list-element="threatColor"></span>
          <div class="gz-data-item--details item-details">
            <div class="gz-data-item--title" gz-list-element="threatName"></div>
            <span class="gz-data-item--value" gz-list-element="threatValue"></span>
          </div>

          <span class="gz-data-item--delta" gz-list-element="threatDelta"></span>
        </li>
        <li class="gz-data-item gz-data-list-item">
          <span class="gz-data-item--bullet" gz-list-element="threatColor"></span>

          <div class="gz-data-item--details item-details">
            <div class="gz-data-item--title" gz-list-element="threatName"></div>
            <span class="gz-data-item--value" gz-list-element="threatValue"></span>
          </div>

          <span class="gz-data-item--delta" gz-list-element="threatDelta"></span>
          </li>
        <li class="gz-data-item gz-data-list-item">
          <span class="gz-data-item--bullet" gz-list-element="threatColor"></span>

          <div class="gz-data-item--details item-details">
            <div class="gz-data-item--title" gz-list-element="threatName"></div>
            <span class="gz-data-item--value" gz-list-element="threatValue"></span>
          </div>

          <span class="gz-data-item--delta" gz-list-element="threatDelta"></span>
        </li>
        <li class="gz-data-item gz-data-list-item">
          <span class="gz-data-item--bullet" gz-list-element="threatColor"></span>

          <div class="gz-data-item--details item-details">
            <div class="gz-data-item--title" gz-list-element="threatName"></div>
            <span class="gz-data-item--value" gz-list-element="threatValue"></span>
          </div>

          <span class="gz-data-item--delta" gz-list-element="threatDelta"></span>
        </li>
        <li class="gz-data-item gz-data-list-item">
          <span class="gz-data-item--bullet" gz-list-element="threatColor"></span>

          <div class="gz-data-item--details item-details">
            <div class="gz-data-item--title" gz-list-element="threatName"></div>
            <span class="gz-data-item--value"  gz-list-element="threatValue"></span>
          </div>
          <span class="gz-data-item--delta" gz-list-element="threatDelta"></span>
        </li>
      </ul>

      <div class="chart-content">
          <div id="topThreatChart" class="widget-chart"></div>
          <div id="threatChartTooltip"></div>
      </div>

      <gz-loader class="widget-loading" rows="5"></gz-loader>
    </div>
  </div>
`;
